// Utils
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';

// Constants
import { CLONE_TYPE, CLONE_DISPLAY_NAME } from './cloneConstants';

const objectConstructorFn = (params) => ({
    ...elementConstructor(params),
    elementType: CLONE_TYPE,
});

export default (params = {}) =>
    registerElementType({
        elementType: CLONE_TYPE,
        objectConstructorFn,
        displayName: CLONE_DISPLAY_NAME,
        ...params,
    });
